// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

import 'normalize.css/normalize.css'// A modern alternative to CSS resets

import Vuex from 'vuex'
import VueCookies from 'vue-cookies'
import Vuelidate from 'vuelidate'
import VuelidateErrorExtractor, {templates} from 'vuelidate-error-extractor'
import PortalVue from 'portal-vue'
import httpVueLoader from 'http-vue-loader'
import upperFirst from 'lodash/upperFirst'
import IdleVue from 'idle-vue'

import App from './App'
import router from './router'
import store from './store'
import i18n from './lang' // Internationalization
import './icons' // icon
import './permission' // permission control

import Element from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'

import '@/styles/index.scss' // global css

import ElFormItemExtended from './components/hook/ElFormItemExtended.vue'

import installPermission from '@/directive/permission/index.js' // 权限判断指令

import ElButtonSvg from '@/components/ElButtonSvg/elbuttonsvg'
import VueScrollactive from '@/components/Scrollactive'
import VueVirtualScroller from 'vue-virtual-scroller'
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css'
import ThreeDotsMenu from '@/components/menu/ThreeDotsMenu'
import Vueditor from 'vueditor'

import 'vueditor/dist/style/vueditor.min.css'

/**
 * If you don't want to use mock-server
 * you want to use mockjs for request interception
 * you can execute:
 *
 * import { mockXHR } from '../mock'
 * mockXHR()
 */
import { mockXHR } from '../mock'
mockXHR()

installPermission(Vue)

Vue.config.productionTip = false

Vue.use(Vuex)
Vue.use(VueCookies)
Vue.use(Vuelidate)
Vue.use(VuelidateErrorExtractor)
Vue.use(PortalVue)
Vue.use(VueScrollactive)
Vue.use(VueVirtualScroller)
Vue.use(Vueditor, {
  toolbar: [
    'removeFormat', 'undo', '|', 'elements', 'fontName', 'fontSize',
    'bold', 'italic', 'underline', 'strikeThrough', 'link', 'unLink', '|',
    'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', '|',
    'insertOrderedList', 'insertUnorderedList', '|', 'sourceCode'
  ],
  fontName: [
    {val: 'arial'},
    {val: 'times new roman'},
    {val: 'Courier New'}
  ],
  fontSize: ['12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px', '36px'],
  uploadUrl: ''
})

const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  store,
  idleTime: 15*60*1000
})

Vue.use(Element, {
  size: 'medium', // set element-ui default size
  i18n: (key, value) => i18n.t(key, value)
})
Vue.component('ElFormItemExtended', ElFormItemExtended)
Vue.component('ElButtonSvg', ElButtonSvg)
Vue.component('ThreeDotsMenu', ThreeDotsMenu)

httpVueLoader.httpRequest = function (pageStr) {
  let page = JSON.parse(pageStr.replace(new RegExp('/index.vue$'), ''))

  // TODO: check using template or layout
  return Promise.resolve(page.template).then((template) => {
    return template
  })
}

// automatic register global components
// "global" - that used without import (including dynamic pages)
const globalComponents = [
  '/HelloWorld.vue',
  '/layout/List/index.vue',
  '/common/FreeSearchFilter.vue',
  '/common/UpdatedBy.vue',
  '/JsonPrint.vue'
]
globalComponents.forEach(fileName => {
  // Получение конфигурации компонента
  let componentConfig = require('@/components' + fileName)

  // Получение имени компонента в PascalCase
  const componentName = upperFirst(
    fileName
      .replace(/^(.*).vue$/, '$1') // remove ".vue" from end
      .replace(/^(.*)\/index$/, '$1') // remove "/index" from end
      .replace(/^.*\/([^/]+)$/, '$1') // substring after last "/"
  )
  // Глобальная регистрация компонента
  Vue.component(
    componentName,
    // Поиск опций компонента в `.default`, который будет существовать,
    // если компонент экспортирован с помощью `export default`,
    // иначе будет использован корневой уровень модуля.
    componentConfig.default || componentConfig
  )
})

// ///////

Vue.prototype.$console = window.console
Vue.prototype.$setData = (object, data) => {
  Object.keys(data).forEach(key => {
    if (data[key] !== null) {
      Vue.set(object, key, data[key])
    } else {
      Vue.delete(object, key)
    }
  })
}

Vue.mixin({
  computed: {
    debug () {
      return process.env.DEBUG_MODE || store.getters.app.devMode
    }
  }
})

/* eslint-disable no-new */
document.MeridianVue = new Vue({
  el: '#app',
  router,
  store,
  i18n,
  components: {App},
  template: '<App/>',
  async onIdle () {
    if (this.$route.path !== '/login') {
      console.warn('idle 15 minutes - logout')
      await this.$store.dispatch('user/logout')
      this.$router.push(`/login`)
    }
  }
})



// WEBPACK FOOTER //
// ./src/main.js